// Canonical business identity used by every LocalBusiness / provider block of
// structured data on the site.
//
// Google connects a website to a Google Business Profile by matching the NAP
// (name, address, phone) and by following `sameAs` to the listing itself. That
// link is what lifts map-pack ranking, so the details below MUST match the
// Google Business Profile exactly — same business name, same phone format,
// same locality. Change them here, never inline on a page.

/** Public Google Business Profile listing. */
export const GOOGLE_BUSINESS_PROFILE_URL = 'https://maps.app.goo.gl/Xd6u1x5wfd1ZHcfW9';
export const BUSINESS_NAME = '206Gravel';
// Registered Washington entity name. Public branding stays "206Gravel"; the
// full legal name belongs on legal pages, receipts, and in structured data as
// `legalName` — a separate property from the display `name`.
export const BUSINESS_LEGAL_NAME = '206Gravel LLC';
export const BUSINESS_PHONE = '+1-206-650-0129';
export const BUSINESS_EMAIL = 'info@206gravel.com';
export const SITE_URL = 'https://206gravel.com';
// Stable node id so every page's schema refers to ONE business entity rather
// than declaring a new, unrelated business on each URL.
export const BUSINESS_ID = `${SITE_URL}/#business`;
// We deliver to customers rather than receiving them, so the profile is a
// service-area business: locality only, no street address.
const ADDRESS = {
  '@type': 'PostalAddress',
  addressLocality: 'Bonney Lake',
  addressRegion: 'WA',
  addressCountry: 'US'
};
const AREA_SERVED = [{
  '@type': 'AdministrativeArea',
  name: 'King County, WA'
}, {
  '@type': 'AdministrativeArea',
  name: 'Pierce County, WA'
}];

/**
 * Full LocalBusiness node. Emit this once on the home page — every other page
 * references the same entity via `localBusinessProvider()`.
 */
export function localBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': BUSINESS_ID,
    name: BUSINESS_NAME,
    legalName: BUSINESS_LEGAL_NAME,
    url: SITE_URL,
    telephone: BUSINESS_PHONE,
    email: BUSINESS_EMAIL,
    priceRange: '$',
    address: ADDRESS,
    areaServed: AREA_SERVED,
    sameAs: [GOOGLE_BUSINESS_PROFILE_URL],
    description: 'Locally owned bulk gravel, rock, soil, bark, and aggregate delivery across King and Pierce counties. Our own trucks and drivers, delivered price up front, pay on delivery.'
  };
}

/**
 * Compact provider reference for Service / Product schema on the city, county,
 * and material pages. Carries the same @id and sameAs so Google resolves it to
 * the one business entity — and to the Google Business Profile.
 */
export function localBusinessProvider() {
  return {
    '@type': 'LocalBusiness',
    '@id': BUSINESS_ID,
    name: BUSINESS_NAME,
    url: SITE_URL,
    telephone: BUSINESS_PHONE,
    address: ADDRESS,
    areaServed: AREA_SERVED,
    sameAs: [GOOGLE_BUSINESS_PROFILE_URL]
  };
}
